import React, { useEffect, useMemo, useState } from "react";
import Topbar from "../components/Topbar";
import Leftbar from "../components/Leftbar";
import { Link } from "react-router-dom";
import {
  displayError,
  displaySuccess,
  getCouponList,
} from "../Utils/utils";
import { toggleLoader } from "../actions/loader";
import { connect } from "react-redux";
import config from "../config/config";
import axios from "axios";
import { Modal } from "react-bootstrap";
import "../Gynac/style.css";

const NriCouponListing = (props) => {
  const [users, setUsers] = useState([]);
  const [limit] = useState(10);
  const [skip, setSkip] = useState(0);
  const [search, setSearch] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const getList = async () => {
    props.toggleLoader(true);
    const res = await getCouponList(limit, skip);
    setUsers(Array.isArray(res) ? res : (res?.data || []));
    props.toggleLoader(false);
  };

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip]);

  const deleteCoupon = async () => {
    if (!deleteTarget?._id) return;
    const token = localStorage.getItem("token");
    setDeleting(true);
    props.toggleLoader(true);
    try {
      await axios.delete(`${config.siteUrl}/delete-coupon/${deleteTarget._id}`, {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      displaySuccess("Deleted Successfully");
      setDeleteTarget(null);
      await getList();
    } catch (error) {
      displayError(error);
    } finally {
      setDeleting(false);
      props.toggleLoader(false);
    }
  };

  const filteredUsers = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return users || [];
    return (users || []).filter((u) => {
      const code = (u?.code || '').toLowerCase();
      const type = (u?.discount_type || '').toLowerCase();
      return code.includes(q) || type.includes(q);
    });
  }, [users, search]);

  return (
    <div className="g-sidenav-show bg-gray-100">
      <div id="wrapper">
        <Leftbar />
        <main className="main-content border-radius-lg">
          <Topbar />

          <div className="header bg-primary pb-6">
            <div className="container-fluid">
              <div className="header-body">
                <div className="row align-items-center py-4">
                  <div className="col-lg-6 col-7">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                      <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                        <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                        <li className="breadcrumb-item"><a href="#">Coupons</a></li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid mt--6"></div>
          <div className="container-fluid">
            <div className="card gynac-card">
              <div className="gynac-card-header">
                <h3 className="gynac-title">
                  Coupons Listing
                  <span className="gynac-count-chip">
                    {filteredUsers.length}{search ? ` of ${users.length}` : ''}
                  </span>
                </h3>

                <div className="gynac-toolbar">
                  <div className="gynac-search">
                    <i className="fas fa-search search-icon" />
                    <input
                      type="text"
                      placeholder="Search code or discount type"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <Link to="/add-coupon">
                    <button className="btn gynac-add-btn">
                      <i className="fas fa-plus" style={{ marginRight: 6 }} />
                      Add Coupon
                    </button>
                  </Link>
                </div>
              </div>

              <div className="table-responsive">
                <table className="gynac-table">
                  <colgroup>
                    <col style={{ width: '24%' }} />
                    <col style={{ width: '18%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '18%' }} />
                    <col style={{ width: '20%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Discount</th>
                      <th>Discount Type</th>
                      <th>Maximum Discount</th>
                      <th style={{ textAlign: 'center' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.map((user) => (
                      <tr key={user?._id}>
                        <td data-label="Code">
                          <span style={{ fontFamily: 'monospace', fontWeight: 700, color: '#c22627', background: '#fdebec', padding: '4px 10px', borderRadius: 6, fontSize: '0.85rem' }}>
                            {user?.code}
                          </span>
                        </td>
                        <td data-label="Discount">
                          <span style={{ fontWeight: 600, color: '#1f2540' }}>{user?.discount}</span>
                        </td>
                        <td data-label="Type" style={{ textTransform: 'capitalize' }}>
                          {user?.discount_type || '—'}
                        </td>
                        <td data-label="Max Discount">
                          <span className="text-muted">{user?.maximum_discount ?? '—'}</span>
                        </td>
                        <td data-label="Action" style={{ textAlign: 'center' }}>
                          <div className="services-action" style={{ display: 'inline-flex', gap: 8 }}>
                            <Link to={`/edit-coupon/${user._id}`}>
                              <button className="btn-pill btn-approve">
                                <i className="fas fa-pen" style={{ marginRight: 5, fontSize: '0.7rem' }} />
                                Edit
                              </button>
                            </Link>
                            <button
                              className="btn-pill btn-reject"
                              onClick={() => setDeleteTarget(user)}
                            >
                              <i className="fas fa-trash" style={{ marginRight: 5, fontSize: '0.7rem' }} />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {!filteredUsers.length && (
                      <tr>
                        <td colSpan={5}>
                          <div className="gynac-empty">
                            <i className="fas fa-tags" />
                            <div className="gynac-empty-text">No coupons found</div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {users && users.length > 0 && (
                <div className="gynac-footer">
                  <span />
                  <div className="paginate-css" style={{ margin: 0, display: 'flex', gap: 8 }}>
                    {skip !== 0 && (
                      <button
                        className="btn-pill btn-approve"
                        style={{ width: 'auto', padding: '6px 18px' }}
                        onClick={() => setSkip(skip - limit)}
                      >
                        <i className="fas fa-chevron-left" style={{ marginRight: 4, fontSize: '0.7rem' }} />
                        Prev
                      </button>
                    )}
                    {users.length === limit && (
                      <button
                        className="btn-pill btn-approve"
                        style={{ width: 'auto', padding: '6px 18px' }}
                        onClick={() => setSkip(skip + limit)}
                      >
                        Next
                        <i className="fas fa-chevron-right" style={{ marginLeft: 4, fontSize: '0.7rem' }} />
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <Modal
            show={!!deleteTarget}
            onHide={() => !deleting && setDeleteTarget(null)}
            centered
            backdrop="static"
          >
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 40, height: 40, borderRadius: '50%', background: '#fdebec', color: '#c22627', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                  <i className="fas fa-exclamation-triangle" />
                </span>
                <h5 className="mb-0" style={{ fontWeight: 700 }}>Delete coupon?</h5>
              </div>
              <button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => !deleting && setDeleteTarget(null)} disabled={deleting}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px', fontSize: '0.95rem', color: '#333' }}>
              Are you sure you want to delete coupon{' '}
              <strong style={{ color: '#1f2540' }}>{deleteTarget?.code || ''}</strong>?
              This action cannot be undone.
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
              <button
                className="btn"
                style={{ background: '#fff', border: '1px solid #d0d4e0', color: '#6b7088', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={() => setDeleteTarget(null)}
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                className="btn"
                style={{ background: '#c22627', color: '#fff', border: '1px solid #c22627', borderRadius: 999, fontWeight: 600, padding: '6px 18px', opacity: deleting ? 0.7 : 1, cursor: deleting ? 'not-allowed' : 'pointer' }}
                onClick={deleteCoupon}
                disabled={deleting}
              >
                <i className="fas fa-trash" style={{ marginRight: 6, fontSize: '0.78rem' }} />
                {deleting ? 'Deleting…' : 'Delete'}
              </button>
            </Modal.Footer>
          </Modal>
        </main>
      </div>
    </div>
  );
};

const mapDispatchToProps = { toggleLoader };
const mapStateToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(NriCouponListing);
